import React, { useState } from 'react';
import useFormSubmit from '../hooks/useFormSubmit';
import './ContactForm.css';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    phone: '',
    email: '',
    message: ''
  });

  // Your Google Apps Script Web App URL
  const sheetUrl = 'https://script.google.com/macros/s/AKfycbw5YlF2Ja0VziGv-CsSYV24wvOISL_Y0_ma4NkSFrdan-JjTcxbKqeNtJGcb_5jV4H3/exec';
  const { submitForm, isSubmitting, submitStatus } = useFormSubmit(sheetUrl);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Include formType to tell the script which sheet to use
    await submitForm({
      ...formData,
      formType: 'contact'  // This sends data to "Contact Submissions" sheet
    });
    
    if (submitStatus === 'success') {
      setFormData({
        name: '',
        company: '',
        phone: '',
        email: '',
        message: ''
      });
    }
  };

  return (
    <div className="form-container">
      <h3>Send us a Message</h3>
      <p>Fill out the form below and we'll get back to you within 24 hours.</p>
      
      {submitStatus === 'success' && (
        <div className="form-message success">
          <span className="message-icon">✓</span>
          Thank you for contacting us! We'll respond shortly.
        </div>
      )}
      
      {submitStatus === 'error' && (
        <div className="form-message error">
          <span className="message-icon">⚠</span>
          Something went wrong. Please try again or contact us directly.
        </div>
      )}

      <form onSubmit={handleSubmit} className="custom-form">
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="name">Full Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="John Doe"
            />
          </div>

          <div className="form-group">
            <label htmlFor="company">Company Name</label>
            <input
              type="text"
              id="company"
              name="company"
              value={formData.company}
              onChange={handleChange}
              placeholder="Your Company Ltd."
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="phone">Phone Number *</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="+254 7XX XXX XXX"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="you@example.com"
            />
          </div>
        </div>

        <div className="form-group full-width">
          <label htmlFor="message">Message *</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            rows="5"
            placeholder="Tell us about your requirements..."
          />
        </div>

        <button 
          type="submit" 
          className="submit-btn"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <span className="spinner"></span>
              Sending...
            </>
          ) : (
            'Send Message'
          )}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;